import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.saaspass-users', {
        url: '/saaspass-users',
        redirectTo: 'company.user-directories.saaspass-users.all-users',
        component: 'companyUserDirectoriesSaaspassUsers',
        resolve: {
        },
    });
}




// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/saaspass-users/saaspass-users.state.js